export default __webpack_public_path__ + "static/media/category.72178f15.svg";